'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CatalogueResultItemButton = require('./components/CatalogueResultItemButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CatalogueResultItemButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/add-title/lib/components/catalogue-result-item-button/index.js
// module id = 978
// module chunks = 1